__turbopack_context__.v({
  "busy": "Button-module__2QGpuG__busy",
  "button": "Button-module__2QGpuG__button",
  "ghost": "Button-module__2QGpuG__ghost",
  "idle": "Button-module__2QGpuG__idle",
  "kind-danger": "Button-module__2QGpuG__kind-danger",
  "kind-plain": "Button-module__2QGpuG__kind-plain",
  "kind-plain-danger": "Button-module__2QGpuG__kind-plain-danger",
  "kind-primary": "Button-module__2QGpuG__kind-primary",
  "kind-secondary": "Button-module__2QGpuG__kind-secondary",
  "kind-secondary-circular": "Button-module__2QGpuG__kind-secondary-circular",
  "kind-secondary-danger": "Button-module__2QGpuG__kind-secondary-danger",
  "size-default": "Button-module__2QGpuG__size-default",
  "size-input": "Button-module__2QGpuG__size-input",
  "size-large": "Button-module__2QGpuG__size-large",
  "size-small": "Button-module__2QGpuG__size-small",
  "srOnly": "Button-module__2QGpuG__srOnly",
});
